module.exports = __webpack_public_path__ + "img/logo-zgdd.8bd2c8b9.png";